import getFolderPaneWidth from './getFolderPaneWidth';
import getLeftRailWidth from './getLeftRailWidth';
import { LEFT_RAIL_STATIC_WIDTH } from '../internalConstants';

/**
 * Gets the current left nav width (folder pane width + left rail width).
 * This width is used to set the width on the div, so the value of this can be 0 depending on if the
 * components are being shown or hidden
 * @returns width in pixels
 */
export default function getLeftNavWidth(): number {
    const totalWidth = getFolderPaneWidth() + getLeftRailWidth();

    /**
     * If totalWidth is 0, the pane is in collapsed state
     */
    if (totalWidth == 0) {
        return LEFT_RAIL_STATIC_WIDTH;
    }

    return totalWidth;
}
